import apiClient from './apiClient';

export const yikiService = {
  getRooms: () => apiClient.get('/yiki/rooms').then((res) => res.data),
  getOverview: () => apiClient.get('/yiki/overview').then((res) => res.data),
  getActiveRound: (roomId) =>
    apiClient.get(`/yiki/rooms/${roomId}/round`).then((res) => res.data),
  getDrawHistory: (roomId) =>
    apiClient.get(`/yiki/rooms/${roomId}/history`).then((res) => res.data),
  getBets: (params) => {
    const query =
      typeof params === 'string' || params == null
        ? params
          ? { roomId: params }
          : undefined
        : params;
    return apiClient
      .get('/yiki/bets', { params: query })
      .then((res) => res.data);
  },
  placeBet: (payload) =>
    apiClient.post('/yiki/bet', payload).then((res) => res.data),
};
